export default {
  namespaced: true, // 定义为独立的命名空间
  state: {
    filterKey: '',
    isDot: {}
  },
  mutations: {
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js